<template>
  <div class="dt-details">
    <div class="dt-details--header">{{$t('venue_details')}}</div>
    <div class="dt-details--body" v-if="venue">
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("location") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.booking_location_name }}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("phone1") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.phone1 }}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("address1") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.address1 }}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("city") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.city }}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("country") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.country }}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("url1") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.url1 }}</div>
          </div>
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("email") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.email }}</div>
          </div>
        </div>
        <div class="dt-details--row">
          <div class="dt-details--label">{{ $t("capacity") }}</div>
          <div class="dt-details--value">
            <div>{{ venue.venue_capacity }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    venue: {
      type: Object,
    },
  },
};
</script>

<style lang="sass" scoped>
.dt-details--label
  padding-left: 5px
</style>


